class CertificateOrderForm{
    static init($form){
        if($form.data('certificate-form-instance')){
            return $form.data('certificate-form-instance');
        }else{
            let instance = new CertificateOrderForm($form)
            $form.data('certificate-form-instance', instance);
            return instance
        }
    }

    constructor($form) {
        this.$form = $form;
        this.$form.find("input[data-input_name='ru']").on('add-subject', function (e, subject) {
            if(this.$form.data('include-releated-relations') === true){
                if(subject.related_users && subject.related_users.length){
                    //surankam visus ueriu ID, kurie neturetu buti itrauktu antra karta
                    let ruInputInstance = this.$form.find('input[data-input_name="ru"]').data('user_code_instance');
                    let ruIds = [];
                    this.$form.find('input[name="ru[]"]').each(function (){
                        //itraukiam susijusius
                        ruIds.push(parseInt($(this).val()))
                    })
                    //itraukia pati gaveja
                    ruIds.push(parseInt(this.$form.data('aid-rceiver')));
                    //
                    subject.related_users.forEach(function (related) {
                        if(ruIds.indexOf(related.id) === -1){
                            //pridedam tik tuos, kurie dar nera itraukti
                            ruInputInstance.addSubject(related, false);
                        }
                    });

                }
            }
            this.$form.submit();

        }.bind(this)).on('remove-subject', function (e){
            this.$form.submit();
        }.bind(this));
    }

}
export default CertificateOrderForm;